import React, { useState, useEffect } from 'react';
import { t } from '../i18n';

function Leaderboard({ user }) {
  const [tab, setTab] = useState('earners');
  const [earners, setEarners] = useState([]);
  const [writers, setWriters] = useState([]);
  const [myEarnerRank, setMyEarnerRank] = useState(null);
  const [myWriterRank, setMyWriterRank] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const headers = user ? { 'Authorization': `Token ${user.token}` } : {};
    Promise.all([
      fetch('/api/leaderboard/earners/', { headers }).then(r => r.json()),
      fetch('/api/leaderboard/writers/', { headers }).then(r => r.json())
    ]).then(([e, w]) => {
      setEarners(e.users || e);
      setWriters(w.users || w);
      setMyEarnerRank(e.my_rank || null);
      setMyWriterRank(w.my_rank || null);
      setLoading(false);
    }).catch(err => { console.error(err); setLoading(false); });
  }, [user]);

  const data = tab === 'earners' ? earners : writers;
  const myRank = tab === 'earners' ? myEarnerRank : myWriterRank;
  const medals = ['🥇', '🥈', '🥉'];

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>{t('lb_title')}</h1>

      {/* My Rank Banner */}
      {user && myRank && (
        <div style={styles.myRankBanner}>
          <span style={{ fontSize: '20px' }}>🎯</span>
          <div>
            <div style={{ fontWeight: 'bold', fontSize: '15px' }}>{t('lb_rank')}</div>
            <div style={{ fontSize: '13px', opacity: 0.9 }}>You are #{myRank} in {tab === 'earners' ? 'Top Earners' : 'Top Writers'}</div>
          </div>
          <div style={styles.myRankNum}>#{myRank}</div>
        </div>
      )}

      {/* Tabs */}
      <div style={styles.tabs}>
        <button style={tab === 'earners' ? styles.tabActive : styles.tab} onClick={() => setTab('earners')}>{t('lb_earners')}</button>
        <button style={tab === 'writers' ? styles.tabActive : styles.tab} onClick={() => setTab('writers')}>{t('lb_writers')}</button>
      </div>

      {/* List */}
      <div style={styles.card}>
        {loading ? <div style={styles.loading}>{t('lb_loading')}</div> :
          data.length === 0 ? <div style={styles.loading}>{t('lb_nodata')}</div> :
          data.map((u, i) => {
            const isMe = user && u.username === user.username;
            return (
              <a href={`/profile/${u.username}`} key={u.username} style={{ ...styles.row, backgroundColor: isMe ? '#f3e5f5' : 'transparent', textDecoration: 'none' }}>
                <span style={{ ...styles.rank, color: i < 3 ? '#34d399' : '#999', fontSize: i < 3 ? '20px' : '14px' }}>
                  {i < 3 ? medals[i] : `#${i + 1}`}
                </span>
                {u.avatar
                  ? <img src={u.avatar} alt={u.username} style={styles.avatar} />
                  : <div style={{ ...styles.avatarPlaceholder, backgroundColor: isMe ? '#6200ea' : '#aaa' }}>{u.username.charAt(0).toUpperCase()}</div>
                }
                <span style={{ ...styles.username, color: isMe ? '#6200ea' : '#333' }}>
                  {u.username} {isMe ? '👈 You' : ''}
                </span>
                <span style={styles.value}>
                  {tab === 'earners' ? `${parseFloat(u.total_earned).toFixed(2)} π` : `${u.post_count} posts`}
                </span>
              </a>
            );
          })
        }
      </div>
      <p style={{ textAlign: 'center', color: '#999', fontSize: '12px', marginTop: '10px' }}>Showing top {data.length} users</p>
    </div>
  );
}

const styles = {
  container: { maxWidth: '800px', margin: '0 auto', padding: '20px' },
  heading: { color: '#6200ea', textAlign: 'center', marginBottom: '16px' },
  myRankBanner: { backgroundColor: '#6200ea', color: 'white', borderRadius: '12px', padding: '14px 20px', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px' },
  myRankNum: { marginLeft: 'auto', fontSize: '28px', fontWeight: 'bold', color: '#34d399' },
  tabs: { display: 'flex', gap: '10px', marginBottom: '16px', justifyContent: 'center' },
  tab: { backgroundColor: '#f3e5f5', color: '#6200ea', border: 'none', padding: '10px 20px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold' },
  tabActive: { backgroundColor: '#6200ea', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '20px', cursor: 'pointer', fontWeight: 'bold' },
  card: { backgroundColor: 'white', borderRadius: '12px', padding: '10px 16px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  row: { display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 8px', borderBottom: '1px solid #eee', borderRadius: '8px' },
  rank: { fontWeight: 'bold', width: '32px', textAlign: 'center' },
  avatar: { width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover' },
  avatarPlaceholder: { width: '36px', height: '36px', borderRadius: '50%', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', flexShrink: 0 },
  username: { flex: 1, fontWeight: 'bold', fontSize: '14px' },
  value: { color: '#6200ea', fontWeight: 'bold', fontSize: '13px' },
  loading: { textAlign: 'center', padding: '30px', color: '#999' },
};

export default Leaderboard;
